export enum ItemOrientation {
	FRONT = "front",
	FRONT2 = "front2",
	TOP = "top",
	TOP2 = "top2",
	SIDE = "side",
	SIDE2 = "side2",
}
